import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useSmOrMdOrLgScreenMediaQuery } from "@circle-react/hooks/useMediaQuery";
import { useMemo } from "react";

import { isCommunityAdmin } from "@/react/helpers/communityMemberHelpers";

const useIsSettingsWorkflowsRoute = (path: string) =>
  useMemo(() => {
    const regex = /^\/settings\/workflows\/(\d+|new|edit|view)(\/.*)?$/;
    const excludeRegex = /^\/settings\/workflows(\?|$)/;
    return regex.test(path) && !excludeRegex.test(path);
  }, [path]);

export const useBannerVisibility = () => {
  const { currentCommunity, currentCommunityMember, currentCommunitySettings } =
    usePunditUserContext();
  const isSmOrMdScreen = useSmOrMdOrLgScreenMediaQuery();
  const isSettingsWorkflowsRoute = useIsSettingsWorkflowsRoute(
    window.location.pathname,
  );

  const isInCommunityCreationPage = useMemo(
    () => window.location.pathname.startsWith("/communities/new"),
    [],
  );

  const isInOnboardingQuestionsPage = useMemo(
    () => /^\/communities\/\d+\/questions\/?$/.test(window.location.pathname),
    [],
  );

  const isInSelectTemplatePage = useMemo(
    () => /^\/communities\/\d+\/templates\/?$/.test(window.location.pathname),
    [],
  );

  const isPromotionBannerEnabled = useMemo(
    () => !!currentCommunity?.promotion_enabled,
    [currentCommunity],
  );

  const isAdmin = isCommunityAdmin(currentCommunityMember);
  const shouldHideTrialBanner = currentCommunitySettings?.hide_trial_banner;

  const shouldHideBanner = Boolean(
    !isAdmin ||
    isInCommunityCreationPage ||
    isInOnboardingQuestionsPage ||
    isInSelectTemplatePage ||
    shouldHideTrialBanner ||
    isSmOrMdScreen ||
    isPromotionBannerEnabled ||
    isSettingsWorkflowsRoute,
  );

  return {
    isAdmin,
    shouldHideTrialBanner,
    isInCommunityCreationPage,
    isInOnboardingQuestionsPage,
    isInSelectTemplatePage,
    isPromotionBannerEnabled,
    isSmOrMdScreen,
    isSettingsWorkflowsRoute,
    shouldHideBanner,
    currentCommunity,
    currentCommunityMember,
    currentCommunitySettings,
  };
};
